// @flow

import { type IncomingPayment } from '@tectonics/prs/incoming-payment';
import { type Receipt } from '@tectonics/prs/receipts';

export function getFinalReceipt(incomingPayment: IncomingPayment): Receipt {
  if (incomingPayment.status === 'OP')
    throw new Error(`FinalReceipt: it's not available in a payment with status: "${incomingPayment.status}"`);

  let finalReceipt = incomingPayment['final_receipt'];

  if(isEgypt(incomingPayment.country)) {
    return forceAmountCurrencyToEGP(finalReceipt);
  }

  return finalReceipt;
}

function forceAmountCurrencyToEGP(receipt: Receipt): Receipt {
  const local_amount = receipt.amount_local_base[1];
  return {
    ...receipt,
    amount_ext: ['EGP', local_amount],
  };
}

function isEgypt(country): boolean {
  return country === 'eg';
}
